import React from 'react';

import { CardSkeleton } from '../../../Skeleton';
import useTimeSeriesData from './useTimeSeriesData';
import TimeSeriesView from './TimeSeriesView';

export { shouldUseComparisonTooltip } from './useTimeSeriesData';

const TimeSeriesContent = ({
  chartDefinition,
  chartRef,
  useSmallNoDataMessage,
}: {
  chartDefinition: V5ChartDefinition;
  chartRef: React.MutableRefObject<any>;
  useSmallNoDataMessage: boolean;
}) => {
  const { options, isNoData, comparison } = useTimeSeriesData({
    chartDefinition,
    chartRef,
  });

  if (!options) {
    return <CardSkeleton />;
  }

  return (
    <TimeSeriesView
      chartRef={chartRef}
      options={options}
      isNoData={isNoData}
      useSmallNoDataMessage={useSmallNoDataMessage}
      remountKey={`${chartDefinition.id}-${comparison}`}
    />
  );
};

export default TimeSeriesContent;
